var Levels = {

    init: function () {
        Levels.disableSelectBaseline();
        Levels.bindClearLevels();
    },

    disableSelectBaseline: function() {
        $('select[id^=level-]').each(function() {
            $(this).on('change', function () {
                if ($(this).val() != '') {
                    $(this).next('p').remove();
                    Levels.analyseLevel($(this));
                } else {
                    $(this).after('<p style="color:red"><strong>Please clear baselines on Assessment Page</strong></p>');
                    return false;
                }
            });
        });
        /* new code in analyseLevel triggers all clearLevelsOn because of basleline
        $('select[id^=level-]').each(function() {
            $(this).find(':selected').trigger('change');
        });
        */
    },

    analyseLevel: function(dropdown) {
        var action = $(dropdown).closest('form').attr('action');
        var parms = action.substring(11);
        var solidus = parms.indexOf('/');
        var pupilId = parms.substring(0, solidus)
        var select = $(dropdown);
        var selectId = $(select).attr('id');
        var subjectId = selectId.substring(6)
        var levelId = 0;
        levelId = $('option', dropdown).filter(':selected').val();
        var level = $('option', dropdown).filter(':selected').text();
        if (levelId) {
            /* method now called by AJAX
            var anchor = $(dropdown).closest('tr').find('a[href*="/clearLevels/"]');
            var href = $(anchor).attr('href');
            if (typeof href !== 'undefined') {
                var clear = href.indexOf('/clearLevels/');
                var newHref = href.substring(0, clear + 13) + levelId;
                $(anchor).attr('href', newHref);
            }
            */
            var btn = $(dropdown).closest('tr').find('button[id^=clearLevels]')
            $(btn).attr('data-baselineId', levelId)

            $.get('/levels/prevAssessment/' + pupilId + '/'  + subjectId + '/' + levelId, function(data) {
                Levels.clearLevelsOff(btn, select, level);
                if (data.hasPrevAssessment || data.baselinedLevelId) {
                    Levels.clearLevelsOn(btn, select, level);
                }
            });
        }
    },

    clearLevelsOff: function(btn, select, level) {
        //$('#levelError').hide();
        $(btn).hide();
        $(select)
            .closest('tr')
            .find('.select2-selection__rendered[title="' + level + '"]')
            .css('color', 'black');
        /* some browsers also consider normal button in form as submit button
        //$(select).closest('form').find(':submit').prop('disabled', false);
        */
        //$('#baselinesSave').prop('disabled', false);
    },

    clearLevelsOn: function(btn, select, level) {
        $('#levelError').show();
        $(btn).show();
        $(select)
            .closest('tr')
            .find('.select2-selection__rendered[title="' + level + '"]')
            .css('color', 'red');
        /* some browsers also consider normal button in form as submit button
        $(select).closest('form').find(':submit').prop('disabled', true);
        */
        $('#baselinesSave').prop('disabled', true);
    },

    bindClearLevels: function() {
        $('button[id^=clearLevels-]').on('click', function(e) {
            e.preventDefault();
            var btn = $(this);
            // the data variable doesn't recognoize mixed case
            var subjectId = $(this).data('subjectid');
            var pupilId = $(this).data('pupilid');
            var baselineId = $(this).data('baselineid');
            var html = '<img src="/images/ajax-loader.gif" class="btn-spinner"> Please wait...';
            $(btn).prop('disabled', true).html(html);
            $.get('/levels/' + subjectId + '/' + pupilId + '/clearLevels/' + baselineId, function(data) {
                $(btn).html('Clear Levels').prop('disabled', false);
                if (!Object.keys(data.starCards).length) {
                    var select = $(btn).closest('tr').find('select[id^=level-]');
                    var level = $('option', select).filter(':selected').text();
                    Levels.clearLevelsOff(btn, select, level);
                }
                var clearLevelButton = false;
                $('button[id^=clearLevels-]').each(function() {
                    if ($(this).is(':visible')) {
                        clearLevelButton = true;
                    }
                });
                if (!clearLevelButton) {
                    $('#levelError').hide();
                    /* some browsers also consider normal button in form as submit button
                    $(select).closest('form').find(':submit').prop('disabled', false);
                    */
                    $('#baselinesSave').prop('disabled', false);
                }
            });
        });
    },
}
